import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const CloseIcon = (p) => (
  <svg {...p} width="1em" height="1em" style={{ fontSize: 'var(--font-size-h4)' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const GripIcon = (props) => (
  <svg {...props} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/>
    <circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/>
  </svg>
);

const fallbackQuestions = [
  { id: 'q1', q: 'What is the primary purpose of a load balancer?' },
  { id: 'q2', q: 'Explain the difference between SQL and NoSQL databases.' },
  { id: 'q3', q: 'What are React Hooks and why are they useful?' }
];

const ReorderQuestionsList = ({ questions = fallbackQuestions, onSave, isOpen = true, onClose = () => {} }) => {


  const [list, setList] = useState([...questions]);
  const [draggedIdx, setDraggedIdx] = useState(null);
  const [dragOverIdx, setDragOverIdx] = useState(null);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  useEffect(()=>{
    setList([...questions])
  },[questions])

  const handleSort = () => {
    if (dragItem.current !== null && dragOverItem.current !== null && dragItem.current !== dragOverItem.current) {
      let _list = [...list];
      const draggedItemContent = _list.splice(dragItem.current, 1)[0];
      _list.splice(dragOverItem.current, 0, draggedItemContent);
      setList(_list);
    }
    dragItem.current = null;
    dragOverItem.current = null;
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-h-650" style={{ maxWidth: '800px' }}>

        {/* Header */}
        <div className="custom-modal-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
            <div style={{ flex: 1 }}>
              <h4 className="fw-bold" style={{ margin: 0, fontSize: 'var(--font-size-h3)' }}>Reorder Questions</h4>
              <p className="text-muted" style={{ margin: '4px 0 0 0', fontSize: 'var(--font-size-base)' }}>Adjust the sequence of your interview questions</p>
            </div>
            <button onClick={onClose} className="text-muted" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 4px 4px 4px' }} title="Close">
              <CloseIcon />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="custom-modal-body">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
            {list.map((q, idx) => (
              <div
                key={q.id || idx}
                draggable
                onDragStart={() => { dragItem.current = idx; setDraggedIdx(idx); }}
                onDragEnter={() => { dragOverItem.current = idx; setDragOverIdx(idx); }}
                onDragEnd={() => { handleSort(); setDraggedIdx(null); setDragOverIdx(null); }}
                onDragOver={(e) => e.preventDefault()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  border: '1px solid var(--ui-border)',
                  borderRadius: '8px',
                  background: draggedIdx === idx ? 'var(--brand-bg)' : '#fff',
                  cursor: 'grab',
                  opacity: draggedIdx === idx ? 0.6 : 1,
                  boxShadow: dragOverIdx === idx && draggedIdx !== idx
                    ? (draggedIdx < idx ? '0 4px 0 0 var(--brand-accent)' : '0 -4px 0 0 var(--brand-accent)')
                    : '0 1px 2px rgba(16, 24, 40, 0.05)',
                }}
              >
                <GripIcon className="text-placeholder font-size-h3" style={{ marginRight: '8px' }} />
                <div className="font-size-base d-flex" style={{ gap: '3px' }}>
                  <span className="fw-bold text-brand-primary" style={{ minWidth: '30px' }}>Q{idx + 1}.</span>
                  <span className="fw-medium text-dark-ui">{q.q || q.text}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="custom-modal-footer">
          <div className="d-flex justify-content-between" style={{ gap: '1rem' }}>
            <button className="btn btn-outline-primary" onClick={onClose}>Cancel</button>
            <button
              className="btn btn-primary"
              onClick={() => {
                if (typeof onSave === 'function') {
                  onSave(list);
                  if (typeof onClose === 'function') onClose();
                }
              }}
            >
              Save Order
            </button>
          </div>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default ReorderQuestionsList;
